export default __webpack_public_path__ + "static/media/bsu-dns.a19838a0.png";